<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button (click)="backToMyProject()">
                                        <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="pl-3">My Project</h3>
                            </div>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end" *ngIf="this.isPMOLeadORManager || this.isAdministrator">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#createIssue">
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                <button type="button" title="Delete" data-bs-toggle="modal" data-bs-target="#deleteIssue" (click)="deleteOpenModal()">
                                    <span><i class="ri-delete-bin-5-line"></i></span>
                                </button>
                            </div>
                            <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#createIssue" class="btn btn-icon">
                                <i class="ri-add-line"></i>
                            </button>
                        </div>
                    </div>
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6 d-flex" *ngIf="!this.parentProjectId">
                            <h3><a (click)="openProjectTab('myparameters')">Details</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('sub-project-list')">Sub-Project </a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('issues')" class="active"> Issues</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('task')"> Tasks</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('resources')"> Resources</a></h3>
                            <!-- <h3><a (click)="this.currentProjectId && openProjectTab('deliverables')"> Deliverables</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('decision-records')"> Decision Records</a></h3> -->
                        </div>
                        <div class="title col-sm-6 d-flex" *ngIf="this.parentProjectId">
                            <h3><a (click)="this.currentProjectId && openProjectTab('sub-project')">Sub-Project</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('issues')" class="active">Issues</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('task')">Tasks</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('resources')">Resources</a></h3>
                          </div>
                    </div>
                    <ag-grid-angular
                        style=" height: 650px" 
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>
  
<!-- Create new createIssue -->
<div class="modal fade bd-example-modal-lg" id="createIssue" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="issueForm">
                <div class="modal-header">
                    <h5 class="modal-title">Create Issue</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="projectId" required>
                                    <label class="floating-label">Project ID</label>
                                    <i class="ri-file-user-line"></i>
                                </div>
                                <mat-error *ngIf="f.projectId.invalid && (f.projectId.dirty || f.projectId.touched)" class="alert alert-danger">
                                    <mat-error *ngIf="f.projectId.errors.required">
                                       Project Id is required
                                    </mat-error>
                                </mat-error> 
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="identifier" >
                                    <label class="floating-label">Identifier</label>
                                    <i class="ri-shield-user-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="issueType" required>
                                    <label class="floating-label">IssueType</label>
                                    <i class="ri-list-check-2"></i>
                                </div>
                                <mat-error *ngIf="f.issueType.touched && f.issueType.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.issueType.errors.required"> IssueType is required</mat-error>
                                </mat-error> 
                            </div>

                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="description" >
                                    <label class="floating-label">Description</label>
                                    <i class="ri-file-list-line"></i>
                                </div>
                             </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="priority">
                                        <!-- <option value="" disabled selected>Priority</option> -->
                                        <option value="Low">Low</option>
                                        <option value="Medium">Medium</option>
                                        <option value="High">High</option>
                                    </select>
                                    <label for="priority" class="floating-label floating-label-special">Priority</label>
                                    <i class="ri-line-chart-line"></i>
                                </div>
                                <mat-error *ngIf="f.priority.touched && f.priority.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.priority.errors.required"> Priority is required</mat-error>
                                 <!-- <mat-error *ngIf="f.priority.errors.pattern">Priority must be between 1 to 5</mat-error> -->
                                </mat-error> 
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <label class="floating-label"></label>
                                    <!-- <input type="text" formControlName="assignedToUserId" required> -->
                                    <input
                                        list="taskOwnerDatalist"
                                        formControlName="assignedToUserId"
                                        
                                    />
                                    <datalist id="taskOwnerDatalist">
                                        <option
                                        [value]="item"
                                        *ngFor="let item of userDropdownList"
                                        ></option>
                                    </datalist>
                                    <label class="floating-label floating-label-special">Assigned To User</label>
                                    <i class="ri-user-line"></i>
                                </div>
                                <mat-error *ngIf="f.assignedToUserId.invalid &&  f.assignedToUserId.touched" class="alert alert-danger">
                                    <mat-error *ngIf="f.assignedToUserId.errors.required">
                                       Assigned to User is required
                                    </mat-error>
                                </mat-error> 
                            </div>
                          
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="department" >
                                    <label class="floating-label">Department</label>
                                    <i class="ri-building-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                            <select formControlName="status">
                                                <!-- <option value="" disabled selected>Status</option> -->
                                                <option value="To Do">To Do</option>
                                                <option value="In Progress">In Progress</option>
                                                <option value="In Review">In Review</option>
                                                <option value="Done">Done</option>
                                            </select>
                                            <label for="status" class="floating-label floating-label-special">Status</label>
                                    <i class="ri-restart-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="trafficLight" >
                                    <label class="floating-label">Traffic Light</label>
                                    <i class="ri-traffic-light-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="action" >
                                    <label class="floating-label">Action</label>
                                    <i class="ri-checkbox-circle-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="resolution" >
                                    <label class="floating-label">Resolution</label>
                                    <i class="ri-shield-check-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="creationDate" required>
                                    <label class="floating-label">Creation Date</label>
                                    <i class="ri-calendar-check-line"></i>
                                </div>
                                <mat-error *ngIf="f.creationDate.touched && f.creationDate.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.creationDate.errors.required">Creation Date is required</mat-error>
                                </mat-error> 
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="targetResolutionDate" required>
                                    <label class="floating-label">Target Resolution Date</label>
                                    <i class="ri-calendar-check-line"></i>
                                </div>
                                <mat-error *ngIf="f.targetResolutionDate.touched && f.targetResolutionDate.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.targetResolutionDate.errors.required">Target Resolution Date is required</mat-error>
                                </mat-error> 
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="finalResolutionDate" required>
                                    <label class="floating-label">Final Resolution Date</label>
                                    <i class="ri-calendar-check-line"></i>
                                </div>
                                 <mat-error *ngIf="f.finalResolutionDate.touched && f.finalResolutionDate.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.finalResolutionDate.errors.required">Final Resolution Date is required</mat-error>
                                </mat-error> 

                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <label class="floating-label"></label>
                                    <!-- <input type="text" formControlName="createdByUserId" required/> -->
                                    <input
                                        list="taskOwnerDatalist"
                                        formControlName="createdByUserId"
                                        placeholder="Created By User"
                                        disabled
                                    />
                                    <!-- <datalist id="taskOwnerDatalist">
                                        <option
                                        [value]="item"
                                        *ngFor="let item of userDropdownList"
                                        ></option>
                                    </datalist> -->
                                    <i class="ri-shield-user-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <!-- <input type="text" formControlName="modifiedByUserId" disabled> -->
                                    <label class="floating-label"></label>
                                    <input
                                        list="taskOwnerDatalist"
                                        formControlName="modifiedByUserId"
                                        placeholder="Modified By User"
                                        disabled
                                    />
                                    <i class="ri-file-user-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createIssue()" [disabled]="!issueForm.valid ? true : null" >Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateIssues()" [disabled]="!issueForm.valid ? true : null" >Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete an item -->
<div class="modal fade" id="deleteIssue" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteLead" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteIssueList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> 
